export default __webpack_public_path__ + "static/media/kinza_bg.ffa03953.jpeg";